(ns net.kestec.mhda-pilgrimage.public.application.application-events
  (:require
    [net.kestec.mhda-pilgrimage.route :as-alias route]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [ajax.core :as ajax]
    [day8.re-frame.http-fx]
    [re-frame.core :as rf]
    ))



(rf/reg-event-fx
  ::set-step
  (fn [{db :db} [_ t]]
    {:dispatch-n
     [[::update-actual-application]
      [::route/push (:name (:data (::route/route db)))
       :path-params (:path-params (::route/route db))
       :query-params (assoc (:query-params (::route/route db))
                       :step t)]]}))
(rf/reg-event-fx
  ::jump-to-step
  (fn [{db :db} [_ pilgrimage application t]]
    {:dispatch-n
     [[::update-actual-application]
      [::route/push
       ::route/onboarding-form
       :path-params {:pilgrimage-id  pilgrimage
                     :application-id application}
       :query-params (assoc (:query-params (::route/route db))
                       :step t)]]}))

(rf/reg-event-fx
  ::store-value
  (fn [{db :db} [_ key val]]
    {:db         (assoc-in db [::db/selected-application key] val)
     :http-xhrio [{:method          :put
                   :uri             (str "/api/pilgrimage/" (get-in db [::db/me :pilgrimage-id])
                                         "/application/" (get-in db [::route/route :path-params :application-id]))
                   :params          (assoc (::db/selected-application db) key val)
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [::db/log-info]
                   :on-failure      [::db/log-error]}]}))

(rf/reg-sub
  ::get-step
  (fn [{:as db {:keys [query-params]} ::route/route} _]
    (or (:step query-params) "0")))


(rf/reg-event-fx
  ::load-application
  (fn [{db :db} [_ _]]
    {:http-xhrio [{:method          :get
                   :uri             (str "/api/pilgrimage/" (get-in db [::route/route :path-params :pilgrimage-id])
                                         "/application/" (get-in db [::route/route :path-params :application-id]))
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [::db/set! ::db/selected-application]
                   :on-failure      [::db/log-error]}]}))

(rf/reg-event-fx
  ::update-actual-application
  (fn [{db :db} _]
    (println "update-actual-application" (get-in db [::route/route :path-params :pilgrimage-id]) " - " (get-in db [::route/route :path-params :application-id]))
    {:http-xhrio [{:method          :put
                   :uri             (str "/api/pilgrimage/" (get-in db [::db/me :pilgrimage-id])
                                         "/application/" (get-in db [::route/route :path-params :application-id]))
                   :params          (::db/selected-application db)
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [::db/set! ::db/selected-application]
                   :on-failure      [::db/log-error]}]}))


(rf/reg-event-fx
  ::store-nurse-documents
  (fn [{db :db} [_ files]]
    {:http-xhrio (mapv (fn [^js file]
                         {:method          :post
                          :uri             (str "/api/pilgrimage/" (get-in db [::db/me :pilgrimage-id])
                                                "/application/" (get-in db [::route/route :path-params :application-id])
                                                "/files")
                          :body            file
                          :headers         {"Content-Type"      "application/octet-stream"
                                            "File-Name"         (.-name file)
                                            "File-Content-Type" (.-type file)
                                            }
                          :response-format (ajax/text-response-format)
                          :on-success      [::nurse-document-uploaded (.-name file) (.-type file)]
                          :on-failure      [::db/log-error]})
                       files)}))


(rf/reg-event-fx
  ::nurse-document-uploaded
  (fn [{db :db} [_ file-name file-type file]]
    (println "::nurse-document-uploaded" file-name file-type file)
    {:db       (update-in db [::db/selected-application :nurse_documents] conj
                          {:file_name file-name
                           :file_type file-type
                           :file      file})
     :dispatch [::update-actual-application]
     }))


(rf/reg-event-db
  ::remove-nurse-document
  (fn [db [_ id]]
    (update-in db [::db/selected-application :nurse_documents] (fn [docs] (remove #(= id (:file %)) docs)))))


(rf/reg-event-fx
  ::store-med-documents
  (fn [{db :db} [_ files]]
    {:http-xhrio (mapv (fn [^js file]
                         {:method          :post
                          :uri             (str "/api/pilgrimage/" (get-in db [::db/me :pilgrimage-id])
                                                "/application/" (get-in db [::route/route :path-params :application-id])
                                                "/files")
                          :body            file
                          :headers         {"Content-Type"      "application/octet-stream"
                                            "File-Name"         (.-name file)
                                            "File-Content-Type" (.-type file)
                                            }
                          :response-format (ajax/text-response-format)
                          :on-success      [::med-document-uploaded (.-name file) (.-type file)]
                          :on-failure      [::db/log-error]})
                       files)}))


(rf/reg-event-fx
  ::med-document-uploaded
  (fn [{db :db} [_ file-name file-type file]]
    ;(println "::med-document-uploaded" file-name file-type file)
    {:db       (update-in db [::db/selected-application :med_documents] conj
                          {:file_name file-name
                           :file_type file-type
                           :file      file})
     :dispatch [::update-actual-application]
     }))


(rf/reg-event-db
  ::remove-med-document
  (fn [db [_ id]]
    (update-in db [::db/selected-application :med_documents] (fn [docs] (remove #(= id (:file %)) docs)))))




(rf/reg-event-db
  ::set-signature-ref
  (fn [db [_ ref]]
    (println "::set-signature-ref" ref)
    ;; set sign
    (when (get-in db [::db/selected-application :sig_image_base64])
      (try (.fromDataURL (get (js->clj ref) "current") (get-in db [::db/selected-application :sig_image_base64]))))
    (assoc-in db [::db/signature-pad :ref] ref)
    ))



(rf/reg-event-fx
  ::save-signature
  (fn [{db :db} _]
    (let [pad (get (js->clj (get-in db [::db/signature-pad :ref])) "current")
          data (.toDataURL pad)]
      (println "::save-signature" pad data)
      {:db       (assoc-in db [::db/selected-application :sig_image_base64] data)
       :dispatch [::update-actual-application]
       }
      )))

(rf/reg-event-fx
  ::clear-signature
  (fn [{db :db} _]
    (let [pad (get (js->clj (get-in db [::db/signature-pad :ref])) "current")]
      (println "::clear-signature" (.clear pad)))))

